module.exports = __webpack_public_path__ + "img/my-page-background@2x.e211962d.png";